import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";

export const StickyCta = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const target = document.getElementById("assessment");
    let formVisible = false;
    let scrolled = false;
    const apply = () => setShow(scrolled && !formVisible);
    const onScroll = () => {
      scrolled = window.scrollY > 640;
      apply();
    };
    const io = new IntersectionObserver(
      ([e]) => {
        formVisible = e.isIntersecting;
        apply();
      },
      { threshold: 0.15 }
    );
    if (target) io.observe(target);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      io.disconnect();
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-mobile-cta"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-[75] bg-[#0B0F17]/95 backdrop-blur-md border-t border-[#26334D] px-4 py-3 flex items-center gap-3"
          style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
        >
          <a
            href="tel:0800322269"
            data-testid="sticky-cta-call"
            aria-label="Call Access X New Zealand"
            className="shrink-0 inline-flex items-center justify-center border border-[#384B70] text-white w-12 h-12 clip-notch-sm"
          >
            <Phone size={18} className="text-[#F4A031]" />
          </a>
          <a
            href="#assessment"
            data-testid="sticky-cta-assessment"
            className="flex-1 inline-flex items-center justify-center gap-2 bg-[#F4A031] text-[#0B0F17] font-grotesk font-bold text-sm h-12 clip-notch-sm"
          >
            Request a site assessment <ArrowRight size={16} />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
